import { render, staticRenderFns } from "./GiveBackAccessToEmployeeModal.vue?vue&type=template&id=9335bd80&scoped=true"
import script from "./GiveBackAccessToEmployeeModal.vue?vue&type=script&lang=js"
export * from "./GiveBackAccessToEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./GiveBackAccessToEmployeeModal.vue?vue&type=style&index=0&id=9335bd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9335bd80",
  null
  
)

export default component.exports